import { onUnmounted, ref, type Ref } from 'vue';

const nowMs = ref(Date.now());
let intervalId: ReturnType<typeof setInterval> | null = null;
let subscriberCount = 0;

/**
 * Shared once-per-second clock so a page of cards re-renders their live
 * "time since check-in" off a single interval. The interval only runs while
 * at least one subscribed component is mounted.
 */
export function useNowTicker(): Ref<number> {
    subscriberCount++;
    if (intervalId === null) {
        nowMs.value = Date.now();
        intervalId = setInterval(() => {
            nowMs.value = Date.now();
        }, 1000);
    }

    onUnmounted(() => {
        subscriberCount--;
        if (subscriberCount === 0 && intervalId !== null) {
            clearInterval(intervalId);
            intervalId = null;
        }
    });

    return nowMs;
}
